import React, { useEffect } from 'react';
import { AuthStateStorageService, LoadingSpinner } from 'common.ui';
import { useMsal } from 'auth/MsalContext';
import { useLocation } from 'react-router-dom';
import Page from '../../components/page/Page';

function LoginStatsforvalteren() {
  const { ensureStatsforvalterenLogin, authInProgress } = useMsal();
  const location = useLocation();

  useEffect(() => {
    if (authInProgress) return;

    const redirectUrl = new URLSearchParams(location.search).get('redirectUrl');

    if (redirectUrl !== null) AuthStateStorageService.setRedirectionState(redirectUrl);

    ensureStatsforvalterenLogin();
  }, [authInProgress, ensureStatsforvalterenLogin, location.search]);

  return (
    <Page header='Log inn som Statsforvalteren' title='Logg inn'>
      <LoadingSpinner />
    </Page>
  );
}

export default LoginStatsforvalteren;
